<script>
  import { Bar, Bubble, Doughnut, Line, Pie, Scatter } from 'svelte-chartjs';
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { generateChartsConfig, generateData } from '@client/utils/charts';
  import { classnames } from '@client/utils/classnames';

  import { CHART_TYPES } from '@client/enums';

  import { generateUUID } from '@common/utils/strings';

  let className = '';
  export { className as class };
  export let chartRef = null;
  export let type = null;
  export let label = null;
  export let title = null;
  export let subtitle = null;
  export let data = generateData();
  export let options = {};
  export let height = '300px';
  export let width = 'auto';
  export let empty = $format('label.NO_DATA_AVAILABLE');
  export let tooltip = null;

  const id = generateUUID();

  $: chartOptions = generateChartsConfig(type, options);
  $: classes = classnames('chart', className);
  $: isEmpty = !data?.datasets?.length;
</script>

<div class={classes}>
  {#if label}
    <div class="label">{@html label}</div>
  {/if}
  {#if title}
    <div class="title">
      <span>{@html title}</span>

      {#if tooltip}
        <Icon name="help-circle" id="tooltip-{id}" />
        <Tooltip target="tooltip-{id}" placement="top">
          {@html tooltip}
        </Tooltip>
      {/if}
    </div>
  {/if}
  {#if subtitle}
    <div class="subtitle">{@html subtitle}</div>
  {/if}

  <div class="chart-container" style="height: {height}; width: {width};" on:touchstart|preventDefault>
    {#if isEmpty}
      <slot name="empty" {empty}>
        <div class="empty">
          <span>{@html empty}</span>
        </div>
      </slot>
    {:else}
      {#if type === CHART_TYPES.line.id}
        <Line bind:this={chartRef} bind:data bind:options={chartOptions} />
      {/if}
      {#if type === CHART_TYPES.pie.id}
        <Pie bind:this={chartRef} bind:data bind:options={chartOptions} />
      {/if}
      {#if type === CHART_TYPES.bar.id}
        <Bar bind:this={chartRef} bind:data bind:options={chartOptions} />
      {/if}
      {#if type === CHART_TYPES.doughnut.id}
        <Doughnut bind:this={chartRef} bind:data bind:options={chartOptions} />
      {/if}
      {#if type === CHART_TYPES.bubble.id}
        <Bubble bind:this={chartRef} bind:data bind:options={chartOptions} />
      {/if}
      {#if type === CHART_TYPES.scatter.id}
        <Scatter bind:this={chartRef} bind:data bind:options={chartOptions} />
      {/if}
    {/if}
  </div>
</div>

<style lang="scss" src="./chart.scss"></style>
